import { render, staticRenderFns } from "./assmentFitChart.vue?vue&type=template&id=cf2bb0fc&scoped=true"
import script from "./assmentFitChart.vue?vue&type=script&lang=js"
export * from "./assmentFitChart.vue?vue&type=script&lang=js"
import style0 from "./assmentFitChart.vue?vue&type=style&index=0&id=cf2bb0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2bb0fc",
  null
  
)

export default component.exports